module.exports = __webpack_public_path__ + "files/401207a0d2c60da92f78c8aaa36589e0.png";